import banner from '../../assets/images/otrlogo.png';

export default function LandingPage() {
    console.log("LandingPage Component Loaded");
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
            <div className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-10 w-9/10 sm:w-3/4 lg:w-1/2 max-w-2xl text-center">
                <img 
                    src={banner} 
                    alt="OTR Banner" 
                    className="mx-auto mb-6 w-80 rounded"
                />
                <h2 className="text-3xl font-semibold text-gray-700 dark:text-gray-200">Welcome to OTR Solutions</h2>
                <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
                    We're excited to work with you. Whether you're confirming rates or verifying information we're here to make the process smooth and efficient.
                </p>
            </div>
            </div>
    );
}